import React, { useState, useEffect } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  CircularProgress,
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Layout from '../components/Layout/Layout';
import apiService from '../services/api';

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 300,
  },
}));

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#1a1a2e',
    color: '#fff',
    fontWeight: 600,
  },
}))(TableCell);

function Users() {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await apiService.getUsers();
      setUsers(data);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    return new Date(dateStr).toLocaleString('en-IN');
  };

  if (loading) {
    return (
      <Layout title="Users" onRefresh={fetchData}>
        <Box className={classes.loadingContainer}>
          <CircularProgress />
        </Box>
      </Layout>
    );
  }

  return (
    <Layout title="Users" onRefresh={fetchData}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>ID</StyledTableCell>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Email</StyledTableCell>
              <StyledTableCell>Created At</StyledTableCell>
              <StyledTableCell>Updated At</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id} hover>
                <TableCell>{user.id}</TableCell>
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{formatDate(user.created_at)}</TableCell>
                <TableCell>{formatDate(user.updated_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Layout>
  );
}

export default Users;
